export enum SegmentCondtionType {
  KEY_VALUE = 'key_value',
  SEGMENT = 'segment',
}

export enum SegmentCondtionAction {
  ANY_OF = 'any_of',
  NONE_OF = 'none_of',
}

type SegmentTargetCondtion = {
  type: SegmentCondtionType.KEY_VALUE | SegmentCondtionType.SEGMENT
  action: string
  ids: any[]
  id: string
}

type Segment = {
  id: string
  conditions: SegmentTargetCondtion[]
}

export type { SegmentTargetCondtion, Segment }
